import { useEffect, useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalFooter from './ModalFooter'
import ModalHeader from './ModalHeader'
import ModalMainWrapper from './ModalMainWrapper'
import { envelopeSwatchStyle } from '../Product/envelopeStyleOptions'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function EnvelopeStyleModal({
    item,
    getValues,
    setValue,
    afterSelection,
    product,
}) {
    const skimModal = ModalStore((state) => state.skim)
    const [selected, setSelected] = useState(getValues(item.name) || '')

    useEffect(() => {
        setSelected(getValues(item.name) || '')
    }, [getValues, item.name])

    const handleConfirm = () => {
        if (!selected) return
        setValue(item.name, selected)
        afterSelection?.(selected)
        skimModal()
    }

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="3xl" spacing="normal">
                <ModalHeader title="Choose an envelope" />
                <ModalContent spacing="normal" scroll={true}>
                    <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-4">
                        {item.options.map((option) => (
                            <button
                                key={option}
                                type="button"
                                onClick={() => setSelected(option)}
                                className={classNames(
                                    selected === option
                                        ? 'border-[#F28230] shadow-[0_0_0_3px_rgba(242,130,48,0.16)]'
                                        : 'border-[#E1DACE]',
                                    'overflow-hidden rounded-xl border-[1.5px] bg-white text-left transition-all duration-150 hover:border-[#F6D9C2]',
                                )}>
                                <div
                                    className="h-[148px] w-full"
                                    style={envelopeSwatchStyle(option, product)}
                                />
                                <div className="px-3 py-2 text-center text-[13px] font-semibold text-olm-black">
                                    {option}
                                </div>
                            </button>
                        ))}
                    </div>
                </ModalContent>
                <ModalFooter
                    confirmText="Select envelope"
                    onConfirm={handleConfirm}
                />
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
